export const TESTING_TOKEN_PARAM = '__clerk_testing_token';
